import './CostBasisTable.scss';

import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import BeaconDisclosureModal from 'components/shared/DisclosureModal/DisclosureModal';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Content from 'services/Content';
import {
  getCostBasisAsOfDateV2,
  getDefaultTaxYear
} from 'state/taxes/TaxSelectors';
import { YEAR_OPTIONS } from 'services/Taxes';
import { FormattedDate } from 'components/shared/Text/Text';
import { getView } from 'state/view/ViewSelectors';
import { getBucketRollData } from 'services/Rest';
import { getIsBucketRollPeriod } from 'state/bucketRoll/BucketRollSelectors';
import UnrealizedCostBasisTableV2 from './UnrealizedCostBasisTableV2';
import { costBasisTableOptions } from 'components/shared/Text/ColumnHeaders';
import RealizedCostBasisTableV2 from './RealizedCostBasisTableV2';
import {
  AAMBeaconTab,
  AAMBeaconTabPanel,
  AAMBeaconTabs
} from 'components/shared/Beacon';
import {ReactComponent as IconHelp} from 'assets/icons/icon-help.svg';
import { CURRENT_YEAR } from 'services/Dates';

const CostBasisTableV2 = (props) => {
  useEffect(() => {
    getBucketRollData();
  }, []);

  const {
    hasCollegeSavingsOnly,
    tableData,
    unrealizedTableData,
    asOfDate,
    view,
    inBucketRollPeriod,
    taxonomyDataV2,
    realizedData,
    isRetirementAdvisoryServiceClient,
    hasURZOrRZFail,
    hasOnlyViewOnlyPerishingAccounts,
    defaultTaxYear,
    preScrollFormatMobile
  } = props;
  const { unrealizedCostBasisRows } = tableData[CURRENT_YEAR];
  const selectedYr = defaultTaxYear === YEAR_OPTIONS[0].value ? '1' : '2';

  return (
    <div>
      <div className="cost-basis-table-wrapper" id="cost-basis-table">
        <div className="cost-basis-table-header-v2 b-typography-sans-serif--headline--500 b-font-weight-bold">
          Cost Basis
          <div className="b-typography-sans-serif--body-loose--100">
            All data as of <FormattedDate>{asOfDate}</FormattedDate>
            <div className="taxes-as-of-date-disclosure-v2">
              <BeaconDisclosureModal
                  title={"Important Information Regarding the Updating of Account Balances"}
                  closeOnClickOut={false}
                  size={'normal'}
                  icon={<IconHelp slot="suffix" aria-label="important information icon"/>}
              >
                <div className="b-typography-sans-serif--headline--300 b-font-weight-bold">Important Information Regarding the Updating of Account Balances</div>
                <br />
                <div className="b-typography-sans-serif--body--100 b-font-weight-light">
                  <Disclosure content={
                    hasCollegeSavingsOnly
                      ? Content.asOfDateDisclosure529Only
                      : Content.asOfDateDisclosure
                    }
                  />
                </div>
                </BeaconDisclosureModal>
            </div>
          </div>
        </div>
        <div className="beacon-on-light">
          <AAMBeaconTabs
            scrollable={false}
            variant={'secondary'}
            tab-type={'standard'}
            selected={
              !preScrollFormatMobile || preScrollFormatMobile.tableTabNum === 1
                ? '1'
                : '2'
            }>
            <AAMBeaconTab
              role={'tab'}
              slot={'tab-children'}
              label={costBasisTableOptions[0].label}
              value={'1'}
            />
            <AAMBeaconTab
              role={'tab'}
              slot={'tab-children'}
              label={costBasisTableOptions[1].label}
              value={'2'}
            />
            <AAMBeaconTabPanel slot="tab-panel" value={'1'}>
              {hasOnlyViewOnlyPerishingAccounts ? (
                <span className="cost-basis-no-data-available">
                  No data available for the criteria selected.
                </span>
              ) : (
                <UnrealizedCostBasisTableV2
                  inBucketRollPeriod={inBucketRollPeriod}
                  costBasisBalances={unrealizedCostBasisRows}
                  view={view}
                  taxonomyDataV2={taxonomyDataV2}
                  unrealizedTableData={unrealizedTableData}
                  isRetirementAdvisoryServiceClient={
                    isRetirementAdvisoryServiceClient
                  }
                  hasURZOrRZFail={hasURZOrRZFail}
                  preScrollFormatMobile={preScrollFormatMobile}
                />
              )}
            </AAMBeaconTabPanel>
            <AAMBeaconTabPanel slot="tab-panel" value={'2'}>
              <AAMBeaconTabs
                scrollable={false}
                variant={'secondary'}
                tab-type={'standard'}
                selected={
                  /* if an anchor url is given, adjust the selected year to show */
                  preScrollFormatMobile && preScrollFormatMobile.tableTabNum > 1
                    ? (preScrollFormatMobile.tableTabNum - 2).toString()
                    : selectedYr
                }>
                <AAMBeaconTab
                  role={'tab'}
                  slot={'tab-children'}
                  label={YEAR_OPTIONS[0].label}
                  value={'3'}
                />
                <AAMBeaconTab
                  role={'tab'}
                  slot={'tab-children'}
                  label={YEAR_OPTIONS[1].label}
                  value={'4'}
                />
                <AAMBeaconTabPanel slot="tab-panel" value={'3'}>
                  {hasOnlyViewOnlyPerishingAccounts ? (
                    <span className="cost-basis-no-data-available">
                      No data available for the criteria selected.
                    </span>
                  ) : (
                    <RealizedCostBasisTableV2
                      costBasisBalances={
                        tableData[YEAR_OPTIONS[0].value]?.realizedCostBasisRows
                      }
                      realizedPershingData={
                        realizedData ? realizedData[YEAR_OPTIONS[0].value] : []
                      }
                      taxonomyDataV2={taxonomyDataV2}
                      hasURZOrRZFail={hasURZOrRZFail}
                      preScrollFormatMobile={preScrollFormatMobile}
                      type={'PRZ'}
                    />
                  )}
                </AAMBeaconTabPanel>
                <AAMBeaconTabPanel slot="tab-panel" value={'4'}>
                  {hasOnlyViewOnlyPerishingAccounts ? (
                    <span className="cost-basis-no-data-available">
                      No data available for the criteria selected.
                    </span>
                  ) : (
                    <RealizedCostBasisTableV2
                      costBasisBalances={
                        tableData[YEAR_OPTIONS[1].value]?.realizedCostBasisRows
                      }
                      realizedPershingData={
                        realizedData ? realizedData[YEAR_OPTIONS[1].value] : []
                      }
                      taxonomyDataV2={taxonomyDataV2}
                      hasURZOrRZFail={hasURZOrRZFail}
                      preScrollFormatMobile={preScrollFormatMobile}
                      type={'CRZ'}
                    />
                  )}
                </AAMBeaconTabPanel>
              </AAMBeaconTabs>
            </AAMBeaconTabPanel>
          </AAMBeaconTabs>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    inBucketRollPeriod: getIsBucketRollPeriod(state),
    defaultTaxYear: getDefaultTaxYear(state),
    asOfDate: getCostBasisAsOfDateV2(state),
    view: getView(state)
  };
};
export default connect(mapStateToProps)(CostBasisTableV2);
